/**
 * Компонент тега статуса события
 * Переиспользуемый компонент для отображения статуса
 */
import React from 'react';
import { Tag } from 'antd';
import { CheckCircleOutlined, ClockCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import type { EventQueueStatus } from '../../../types/plantingEvents';
import { EVENT_STATUS_CONFIG, eventStatusLabel } from '../utils/eventFormatters';

interface EventStatusTagProps {
  status: EventQueueStatus;
}

export const EventStatusTag: React.FC<EventStatusTagProps> = ({ status }) => {
  const config = EVENT_STATUS_CONFIG[status] || EVENT_STATUS_CONFIG.planned;
  
  const getIcon = () => {
    switch (status) {
      case 'completed':
        return <CheckCircleOutlined />;
      case 'cancelled':
        return <CloseCircleOutlined />;
      default:
        return <ClockCircleOutlined />;
    }
  };

  return (
    <Tag color={config.color} icon={getIcon()}>
      {eventStatusLabel(EVENT_STATUS_CONFIG[status] ? status : 'planned')}
    </Tag>
  );
};
